var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"func-10"}},[_c('funcionalidade-header',{attrs:{"titulo":_vm.tituloNavegacao}}),_c('div',{staticClass:"main"},[_c('SolicitacaoListagemGeral',{attrs:{"funcionalidade":_vm.funcionalidade,"rota-detalhe":_vm.rotaDetalhe,"rota-historico":_vm.rotaHistorico}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }